exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mastercard-icon .cls-1{\n  fill:#64b5f6;\n}\n\n.mastercard-icon .cls-2{\n  fill:#37474f;\n}\n\n.mastercard-icon .cls-3{\n  fill:#ff6f00;\n}\n\n.mastercard-icon .cls-4{\n  fill:#ffb300;\n}\n\n.mastercard-icon .cls-5{\n  fill:#d50000;\n}\n", ""]);
